import React, { useState } from "react";
import BootstrapSwitchButton from 'bootstrap-switch-button-react';


const ToggleSwitch = ({ onlabel, offlabel, onClick, checked }) => {

  const [isChecked, setIsChecked] = useState(checked);

  const handleToggle = () => {
    setIsChecked(!isChecked);
    if (onClick) {
      onClick(!isChecked);
    }
  };

  return (
    <div>
      <BootstrapSwitchButton
        checked={isChecked}
        onlabel={onlabel}
        offlabel={offlabel}
        onChange={handleToggle}
        width={110}
        onstyle="primary"
      />
    </div>
    // <div className="toggle-switch" onClick={handleToggle}>
    //   {/* {label}{" "} */}
    //   <input type="checkbox" className="checkboxtoggle" defaultChecked={isChecked} name={label} id={label} />
    //   <label className="label" htmlFor={label}>
    //     <span className="inner" />
    //     <span className="switch" />
    //   </label>
    // </div>
  );
};

export default ToggleSwitch;


